import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, NgForm, FormBuilder } from '@angular/forms';
import { Invoicetrackreq } from 'src/app/model/invoicetrackreq.model';
import { isNullOrUndefined } from 'util';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';

@Component({
  selector: 'app-invoiceupload',
  templateUrl: './invoiceupload.component.html',
  styleUrls: ['./invoiceupload.component.css']
})
export class InvoiceuploadComponent implements OnInit {
  data: any;
  purchaseOrder: any;
  files: File[];
  form: FormGroup;
  vendorDrawing: Invoicetrackreq;
  drawingDocs: any;

  purchaseLines: any;
  showlines: boolean = false;
  savedid: number;

  isSaveError: boolean = false;
  isSaveSuccess: boolean = false;
  isLoading: boolean = false;
  grandTotal: number;
  constructor(private invoiceservice: InvoiceService, private router: Router,
    private route: ActivatedRoute, private fb: FormBuilder, private engineeringservice: EngineeringService) {
    this.form = this.fb.group({
      avatar: null
    });
  }

  ngOnInit() {
    this.getPurchaseOrderList();
  }

  onFileChange(event) {
    //alert("selected");
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.form.get('avatar').setValue(file);

      console.log(this.form.get('avatar').value);
    }
  }

  getPurchaseOrderList() {
    //alert("pp");
    debugger;
    // this.invoiceservice.GetPurchaseOrderList().subscribe(
    //   data => {
    //     this.purchaseOrder = data;
    //     console.log(data);
    //   }
    // )
    this.engineeringservice.GetPurchaseOrderForVendor().subscribe(
      data => {
        this.purchaseOrder = data;
        console.log(data);
      }
    )
  }
  UploadFilesForm(form: NgForm) {
    debugger;
    //alert("aaaa");
    var quanterror = false;
    this.isLoading = true;
    console.log(form.value);
    let input = new FormData();
    input.append('avatar', this.form.get('avatar').value);
    //input.append('itemNo', form.value.itemNo);
    input.append('poNo', form.value.poNo);
    input.append('invoiceDate', form.value.invoiceDate);
    input.append('approvalCfo', form.value.approvalCfo);
    //input.append('invoiceLine', this.data)

    //console.log(this.form.get('avatar').value);
    console.log(input);
    console.log(this.data);

    //create temp object
    // const invoicedata  = {
    //   poNo : form.value.poNo,
    //   invoiceLine : this.data
    // };
    //create temp object
    debugger;
    for (var i = 0; i < this.data.length; i++) {
      if (parseInt(this.data[i].invoiceQuantity) > parseInt(this.data[i].quantity)) {
        quanterror = true;
      }
    }

    if (!quanterror) {
      this.invoiceservice.uploadVendorInvoice(input).subscribe(
        (data: any) => {
          if (data.status == true) {
            this.savedid = data.docid;
            console.log(data);
            this.saveInvoiceLines(this.savedid);
            this.form.reset();
            this.isLoading = false;
          }
          else {
            this.isLoading = false;
            this.isSaveError = true;
          }
        }
      );
    }
    else {
      alert("Invoice quantity can't be more than Po quantity");
      this.isLoading = false;
    }

  }

  saveInvoiceLines(docid) {

    for (var i = 0; i < this.data.length; i++) {
      this.data[i].vendorInvoiceId = docid;
    }

    this.invoiceservice.saveVendorInvoiceLines(this.data).subscribe(
      (data: any) => {
        this.isLoading = false;
        this.isSaveSuccess = true;
      }
    )

  }

  onSelectPurchase(purhcaseno) {
    this.showlines = false;

    this.invoiceservice.getInvoiceLines(purhcaseno).subscribe(
      (data: any) => {
        this.data = data;

        for (var i = 0; i < this.data.length; i++) {
          var unicost = this.data[i].unitCost;
          unicost = unicost.replace(/\,/g, '');
          this.data[i].unitCost = unicost;

          var quantty = this.data[i].quantity;
          quantty = quantty.replace(/\,/g, '');
          this.data[i].quantity = quantty;

          //lineTotal = parseInt(unicost) * parseInt(quantty);
          //this.grandTotal = this.grandTotal + lineTotal;
        }

        console.log(this.data);
        this.showlines = true;
      }
    )

  }

  caculateTotal() {
    var lineTotal = 0;
    this.grandTotal = 0;

    for (var i = 0; i < this.data.length; i++) {
      var unicost = this.data[i].unitCost;
      unicost = unicost.replace(/\,/g, '');
      this.data[i].unitCost = unicost;

      var quantty = this.data[i].quantity;
      quantty = quantty.replace(/\,/g, '');
      this.data[i].quantity = quantty;

      var invquantty = this.data[i].invoiceQuantity;
      invquantty = invquantty.replace(/\,/g, '');
      this.data[i].invoiceQuantity = invquantty;

      this.data[i].extraLineField1 = unicost * invquantty;
      //lineTotal = parseInt(unicost) * parseInt(quantty);
      if (invquantty != null || invquantty != 0) {
        this.grandTotal = this.grandTotal + this.data[i].extraLineField1;
      }

    }
  }

}
